module.exports = hzero_dll_vendors;